<template>
  <div style="padding:0 6px">
    <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse;" width="100%">
		<tbody>
			<tr>
				<td class="stylehead">
					<img src="https://api.dianzibiaopai.top/public/content/logo/gy.png" alt="head" style="margin: 2px 2px 2px 2px; height: 80px;width: 100%;">
				</td>
			</tr>
		</tbody>
	</table>
    <div id="gradient-style" style="margin-top: 16px;">
    <table  caption="产品信息" width="100%" class="auto-style15">
		<thead>
			<tr>
				<th scope="col" colspan="4" class="auto-style11">产品信息</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td width="20%">&nbsp;&nbsp;品&nbsp;名：</td>
				<td class="auto-style14" colspan="3">{{info.name}}</td>
			</tr>
			<tr>
				<td width="13%">&nbsp;&nbsp;标&nbsp;准：</td>
				<td width="35%">
					{{ info.standards }}
				</td>
				<td width="14%">&nbsp;日&nbsp;期：</td>
				<td class="auto-style16">{{getDate(info.date)}}</td>
			</tr>
			<tr>
				<td>&nbsp;&nbsp;牌&nbsp;号：</td>
				<td>{{info.brand}}</td>
				<td>&nbsp;规&nbsp;格：</td>
				<td>Φ{{info.specifications }}</td>
			</tr>
			<tr>
				<td>&nbsp;&nbsp;批&nbsp;号：</td>
				<td>{{info.batch}}</td>
				<td>&nbsp;&nbsp;重&nbsp;量：</td>
				<td>{{ info.weight }}</td>
			</tr>
			<!--<tr>
			<td>&nbsp;序&nbsp;号：</td>
				<td class="auto-style16">8006 </td>
			<td>&nbsp;支&nbsp;数：</td>
				<td class="auto-style16">1 </td>
			</tr>-->
		</tbody>
	</table>
</div>
    <h3 class="title">成分信息</h3>
    <div v-html="info.chemistrydesc" class="chemistry-table7" id="gradient-style"></div>
    <h3 class="title">物理性能</h3>
    <div v-html="info.physicsdesc" class="chemistry-table7" id="gradient-style"></div>
    官方地址：<a href="http://www.sxgygtyxgs.com/">http://www.sxgygtyxgs.com/</a>
  </div>
</template>

<script>
export default {
    props:['info'],
	methods:{
		getDate(date){
			let arr = date.split('-')
			let rtn = ''
			for(let i of arr){
				rtn+=i
			}
			return rtn
		}
	}
	
}
</script>

<style scoped>
.title{
    background: #F2F2F2;
    color:#333;
    padding:6px;
    border: solid 1px #ddd;
    font-size: 20px;
    margin-top:20px;
}
/deep/ #gradient-style table {
				border-collapse: collapse;
				width: 100%;
			}
			
			/deep/ #gradient-style th, /deep/ #gradient-style td {
				border: 1px solid #ddd;
				padding: 8px;
			}
			
			/deep/ #gradient-style th {
				background-color: #f2f2f2;
				text-align: left;
			}
			
			/deep/ #gradient-style tbody tr:nth-child(even) {
				background-color: #f2f2f2;
			}
			
			/deep/ #gradient-style tbody tr:hover {
				background-color: #ddd;
			}
			
			.auto-style11 {
				font-size: 20px;
				font-weight: bold;
				color: #333;
			}
</style>


// WEBPACK FOOTER //
// src/components/manufacturers1.vue